var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89648 8C1.89648 4.64169 5.05624 1.75 9.17758 1.75C13.2989 1.75 16.4587 4.64169 16.4587 8C16.4587 8.64183 16.3433 9.26661 16.1278 9.85742C15.9383 10.3769 16.2859 11 16.8389 11C17.1092 11 17.3582 10.8455 17.4588 10.5945C17.7819 9.78798 17.9587 8.91586 17.9587 8C17.9587 3.62632 13.9272 0.25 9.17758 0.25C4.42802 0.25 0.396484 3.62632 0.396484 8C0.396484 12.3737 4.42802 15.75 9.17758 15.75C9.91354 15.75 10.6322 15.6689 11.3214 15.5157C11.639 15.445 11.8546 15.1564 11.8546 14.831C11.8546 14.333 11.3637 13.9811 10.8757 14.0806C10.3335 14.1912 9.7653 14.25 9.17758 14.25C5.05624 14.25 1.89648 11.3583 1.89648 8Z",
    fill: "#516975"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17773 4V8L11.4723 10",
    stroke: "#516975",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a5e22fe13654368c3d4bb68a050243c0.svg";
export { ForwardRef as ReactComponent };